import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
} from "@angular/router";
import { PermissionService } from "../services/permission.service";
import { EntityRouteData } from "./permissionRedirect.guard";
import { RoutePaths } from "../shared/constants/routePaths.constants";

@Injectable({
    providedIn: "root",
})
export class EntityPermissionGuard {
    constructor(
        private permissionService: PermissionService,
        private router: Router,
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): boolean {
        const objectId = (route.data as EntityRouteData)?.objectId;
        if (!objectId) return true;

        if (this.permissionService.hasReadPermission(objectId)) {
            return true;
        }

        this.router.navigate([RoutePaths.unauthorized]);
        return false;
    }
}
